<template>
<div>

<ContentHeader :title="$store.state.languages.lang_phrases.tedarikci_bilgileri"  :show_button="false" ></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>




<template v-if="!loading">
<div class="mt-4">
<ClickEditInputText  :title="$store.state.languages.lang_phrases.tedarikci_ismi" :value="item.name" valkey="name" @dataChanged="dataChanged"></ClickEditInputText>

<!--<ClickEditInputText  title="Tedarikçi Kodu" :value="item.suppliercode" valkey="suppliercode" @dataChanged="dataChanged"></ClickEditInputText>-->



<div class="grid" >

<div class="col-3 md:col-2"><p class="click_edit_value_title">{{$store.state.languages.lang_phrases.marka_bildirisi}}:</p></div>
<div class="col-9 md:col-10">
<Button type="button"  :label="$store.state.languages.lang_phrases.goruntulemek_icin_tiklayin" @click="showBrandInfo" icon="pi pi-eye"  class="p-button-primary p-button-outlined p-button-sm mr-2 mt-3"   />
</div>
</div>





<template v-for="attribute in attributes">
  <template v-if="attribute.type=='string'">
    <template v-for="translation in attribute.translations">
      <ClickEditInputText v-show="translation.language_id == $store.state.auth.user.preflang_id" :title="attribute.name" :value="attribute.supplierattributes[0].attibutetextval" :valkey="attribute.id" @dataChanged="attributeChanged"></ClickEditInputText>
    </template>
    
  </template>

  <template v-if="attribute.type=='number'">
    <template v-for="translation in attribute.translations">
    <ClickEditNumber v-show="translation.language_id == $store.state.auth.user.preflang_id"  :title="attribute.name" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" @dataChanged="attributeChanged" />
    </template>
  </template>

  <template v-if="attribute.type=='boolean'">
    <template v-for="translation in attribute.translations">
    <ClickEditSwitch  v-show="translation.language_id == $store.state.auth.user.preflang_id"  :title="attribute.name" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" @dataChanged="attributeChanged" />
    </template>

    
  </template>

  <template v-if="attribute.type=='select'">
    <template v-for="translation in attribute.translations">
    <ClickEditSelect  v-show="translation.language_id == $store.state.auth.user.preflang_id"  :title="attribute.name" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" @dataChanged="attributeChanged" valkey="languages" :options="attribute.options"  :read_only="true" :color_selector="true"/>
    </template>
    
  </template>


</template>


</div>

<Dialog :header="item.brand.name + ' '+$store.state.languages.lang_phrases.marka_bildirisi" v-model:visible="show_brand_info" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '80vw'}" :modal="true">

<ScrollPanel style="width: 100%; height: 500px">

<div v-for="translation in item.brand.translations" v-show="translation.language_id == $store.state.auth.user.preflang_id" v-html="translation.description"> </div>
</ScrollPanel>




</Dialog>


</template>









</div>



</template>

<script>
export default {

  name: 'SupplierBrandDetailBrandInfo',

  data () {
    return {
      item:null,
      loading:true,     
      attributes:[],
      show_brand_info:false,
    }
  },
  mounted()
  {
    this.$store.dispatch('ui/setActiveTab',"marka") 
    console.log(this.$route.params)
    this.getData()
  },
  methods:{
    showBrandInfo()
    {
      this.show_brand_info = true
    },
    async getData()
    {
        this.item = await this.generalApiGetWithoutLoader("get_supplier_data/"+this.$route.params.brand_uuid)
        console.log(this.item)
        this.attributes = await this.generalApiGetWithoutLoader("supplier_brand_attributes/"+this.$route.params.brand_uuid)
        console.log(this.attributes)
        this.$store.dispatch('suppliers/setSupplier',this.item) 
        this.loading = await false
    },
    dataChanged(data)
    {
      console.log(data)
      let formdata = new FormData()
      formdata.append(data.key,data.value)
      this.generalSubmission(formdata,"supplier/"+this.item.id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      this.getData()
            
    },
    attributeChanged(data)
    {
      console.log(data)
      //return false
      let formdata = new FormData()
      formdata.append("data",data.value)
      formdata.append("customattribute_id",data.key)
      this.generalSubmission(formdata,"supplier/update_custom_attribute_val/"+this.item.id,this.afterdataChanged)
    },

  }
}
</script>

<style lang="css" scoped>
</style>